import React, { useState } from 'react'
import { Modal, Button, Table, Form } from 'react-bootstrap'

interface SelectCouponModalProps {
  show: boolean
  onHide: () => void
  coupons: any[]
  onSelect: (couponId: string) => void
}

const SelectCouponModal: React.FC<SelectCouponModalProps> = ({
  show,
  onHide,
  coupons,
  onSelect,
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  const filteredCoupons = coupons.filter((coupon) =>
    Object.values(coupon).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Select Coupon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Control
            type="text"
            placeholder="Search coupons..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form.Group>

        <div style={{ height: '500px', overflowY: 'auto' }}>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Percent Off</th>
                <th>Amount Off</th>
                <th>Duration</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {filteredCoupons.map((coupon) => (
                <tr key={coupon.id}>
                  <td>{coupon.id}</td>
                  <td>{coupon.name}</td>
                  <td>{coupon.percent_off ? `${coupon.percent_off}%` : '-'}</td>
                  <td>
                    {coupon.amount_off
                      ? `$${(coupon.amount_off / 100).toFixed(2)}`
                      : '-'}
                  </td>
                  <td>{coupon.duration}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => onSelect(coupon.id)}
                    >
                      Select
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectCouponModal
